module.exports = __webpack_public_path__ + "img/02-4.f6cdd612.png";